import React from 'react'
import NavBarLink from '../../Layout/shared/NavBarLink'

import { EMAILS_ROOT } from './routePaths'

const MailsNavbarLink = () => <NavBarLink path={EMAILS_ROOT} title="Emails" />

export default MailsNavbarLink
